import { Component, Input, OnInit } from "@angular/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { taskSubtaskMaster } from "src/app/Models/BasicForms/taskSubtaskMaster";
import { Role } from "src/app/Models/Commonmodule/role";
import { ApiService } from "src/app/Service/api.service";

@Component({
  selector: "app-task-subtask-mapping",
  templateUrl: "./task-subtask-mapping.component.html",
  styleUrls: ["./task-subtask-mapping.component.css"],
})
export class TaskSubtaskMappingComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: taskSubtaskMaster;
  @Input() mappingData: [];

  TASK_CATEGORY_ID = 0;
  USER_ID = 1;
  IS_ACTIVE = true;
  searchText = "";

  constructor(
    private notificationSer: NzNotificationService,
    public _apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.loadAllCategories();
    this.loadRoles();
  }

  displayFilterBox = false;
  flterBoxVisibleInvisible() {
    this.displayFilterBox = !this.displayFilterBox;
  }

  filterButtonType = "default";
  filterIsAppliedOrNot() {
    // if (this.chillingCenterID.length > 0) {
    //   this.filterButtonType= "primary";
    // } else {
    //   this.filterButtonType= "default";
    // }
  }

  close() {
    this.drawerClose();
    this.isSpinning = false;
  }

  isSpinning = false;

  save(addNew: boolean) {
    this.isSpinning = true;
    // this.gettingAssigneeList();

    this._apiService
      .addTaskSubtaskMappingDetails(this.data.ID, this.mappingData)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
          this.notificationSer.success("Task Mapping Done Successfully", "");

          // Update New Assignee
          if (this.data.PARENT_ID == 0) {
            this.data.TYPE = 4;
          } else {
            this.data.TYPE = 5;
          }


          var assigndata = [];
          for (var i = 0; i < this.mappingData.length; i++) {
            if (this.mappingData[i]["IS_ACTIVE"] == 1) {
              assigndata.push(Number(this.mappingData[i]["USER_ID"]));
            }
          }

          // console.log(assigndata, "assigndata");

          var dataaa = {
            TYPE: this.data.TYPE,
            REFERENCE_ID: this.data.ID,
            REPORTER_ID: this.data.REPORTER_ID,
            CLIENT_ID: 1,
            ASSIGNEES: assigndata,
          };

          this._apiService.updateTaskSubtasknew(dataaa).subscribe(
            (successCode) => {
              if (successCode["code"] == "200") {
                this.notificationSer.success("Task Updated Successfully", "");
                this.isSpinning = false;
              } else {
                this.notificationSer.error("Failed to Update Task", "");
                this.isSpinning = false;
              }
            },
            (err) => {
              if (err["ok"] == false) {
                this.notificationSer.error("Server Not Found", "");
              }
            }
          );

          if (!addNew) {
            this.drawerClose();
          } else {
            // this.TASK_CATEGORY_ID = 1;
            this.onCategoryChange();
          }
        } else {
          this.notificationSer.error("Task Mapping Failed", "");
          this.isSpinning = false;
        }
      });
  }

  assigneeList = [];
  sortedAssigneeList = [];

  preAssigneeList = [];
  newPreAssigneeList = [];
  sortedNewPreAssigneeList = [];

  assigneeListToUpdate = [];

  gettingAssigneeList() {
    this.assigneeList = [];
    this.sortedAssigneeList = [];
    this.preAssigneeList = [];
    this.newPreAssigneeList = [];
    this.sortedNewPreAssigneeList = [];
    this.assigneeListToUpdate = [];

    for (var i = 0; i < this.mappingData.length; i++) {
      if (this.mappingData[i]["IS_ACTIVE"] == 1) {
        this.assigneeList.push(Number(this.mappingData[i]["USER_ID"]));
      }
    }

    this.sortedAssigneeList = this.assigneeList.sort((n1, n2) => n1 - n2);

    if (this.data["PARENT_ID"] == 0) {
      if (this.data["TASK_ASSIGNEE_IDS"] != null) {
        this.preAssigneeList = this.data["TASK_ASSIGNEE_IDS"].split(",");
      }
    } else {
      if (this.data["SUBTASK_ASSIGNEE_IDS"] != null) {
        this.preAssigneeList = this.data["SUBTASK_ASSIGNEE_IDS"].split(",");
      }
    }

    for (var i = 0; i < this.preAssigneeList.length; i++) {
      this.newPreAssigneeList.push(Number(this.preAssigneeList[i]));
    }

    this.sortedNewPreAssigneeList = this.newPreAssigneeList.sort(
      (n1, n2) => n1 - n2
    );

    // Getting Unique Element
    let unique1 = this.sortedAssigneeList.filter(
      (o) => this.sortedNewPreAssigneeList.indexOf(o) === -1
    );
    let unique2 = this.sortedNewPreAssigneeList.filter(
      (o) => this.sortedAssigneeList.indexOf(o) === -1
    );
    this.assigneeListToUpdate = unique1.concat(unique2);
  }

  onAssigneeChange() {
    this.data.TASK_CATEGORY_ID = this.data.TASK_CATEGORY_ID;
    this.data.FEATURE_ID = this.data.FEATURE_ID;
    this.data.PARENT_ID = this.data.PARENT_ID;
    this.data.NAME = this.data.NAME;
    this.data.DESCRIPTION = this.data.DESCRIPTION;
    this.data.ESTIMATED_HOURS = 0;
    this.data.ESTIMATED_MINUTES = 0;
    this.data.ESTIMATED_SECONDS = 0;

    this.data.PRIORITY = this.data.PRIORITY;

    this.data.TIME_TRACKED = this.data.TIME_TRACKED;
    this.data.STATUS = this.data.STATUS;

    this.data.START_DATE = this.data.START_DATE;
    this.data.END_DATE = this.data.END_DATE;

    this.data.IS_CHILD = this.data.IS_CHILD;
    this.data.DEPENDENT_TASK_ID = this.data.DEPENDENT_TASK_ID;

    this.data.UPDATED_DATETIME = this.data.UPDATED_DATETIME;

    this.data.TAGS = this.data.TAGS;
    this.data.PROGRESS = this.data.PROGRESS;
    this.data.IS_ACTIVE = true;

    if (this.data.PARENT_ID == 0) {
      this.data.TYPE = 4;
    } else {
      this.data.TYPE = 5;
    }

    this.data.ASSIGNEES = this.assigneeListToUpdate;
    this.data.REPORTER_ID = this._apiService.userId;

    if (
      this.assigneeListToUpdate.length != 0 &&
      this.sortedAssigneeList.length > this.sortedNewPreAssigneeList.length
    ) {
      this._apiService.updateTaskSubtask(this.data).subscribe(
        (successCode) => {
          if (successCode["code"] == "200") {
            this.notificationSer.success("Task Updated Successfully", "");
          } else {
            this.notificationSer.error("Failed to Update Task", "");
          }
        },
        (err) => {
          if (err["ok"] == false) {
            this.notificationSer.error("Server Not Found", "");
          }
        }
      );
    }
  }

  categoryList = [];

  loadAllCategories() {
    this._apiService
      .getAllCategories(0, 0, "ID", "desc", " and IS_ACTIVE=1")
      .subscribe(
        (categoryData) => {
          this.categoryList = categoryData["data"];
        },
        (err) => {}
      );
  }

  loadingRecords = false;

  onCategoryChange() {
    this.loadingRecords = true;

    this._apiService.getTaskSubtaskDetails(this.data.ID, 0).subscribe(
      (data) => {
        this.loadingRecords = false;

        this.mappingData = data["data"];
      },
      (err) => {}
    );
  }

  roles: Role[];
  roleLoading = false;

  loadRoles() {
    this.roleLoading = true;
    this._apiService
      .getAllRoles(0, 0, "", "", " and ID not in (1,2)")
      .subscribe(
        (roles) => {
          this.roles = roles["data"];
          this.roleLoading = false;
        },
        (err) => {
          this.roleLoading = false;
        }
      );
  }

  onAssigneeChange11() {
    this.data.TASK_CATEGORY_ID = this.data.TASK_CATEGORY_ID;
    this.data.FEATURE_ID = this.data.FEATURE_ID;
    this.data.PARENT_ID = this.data.PARENT_ID;
    this.data.NAME = this.data.NAME;
    this.data.DESCRIPTION = this.data.DESCRIPTION;
    this.data.ESTIMATED_HOURS = 0;
    this.data.ESTIMATED_MINUTES = 0;
    this.data.ESTIMATED_SECONDS = 0;

    this.data.PRIORITY = this.data.PRIORITY;

    this.data.TIME_TRACKED = this.data.TIME_TRACKED;
    this.data.STATUS = this.data.STATUS;

    this.data.START_DATE = this.data.START_DATE;
    this.data.END_DATE = this.data.END_DATE;

    this.data.IS_CHILD = this.data.IS_CHILD;
    this.data.DEPENDENT_TASK_ID = this.data.DEPENDENT_TASK_ID;

    this.data.UPDATED_DATETIME = this.data.UPDATED_DATETIME;

    this.data.TAGS = this.data.TAGS;
    this.data.PROGRESS = this.data.PROGRESS;
    this.data.IS_ACTIVE = true;

    if (this.data.PARENT_ID == 0) {
      this.data.TYPE = 4;
    } else {
      this.data.TYPE = 5;
    }

    this.data.ASSIGNEES = this.assigneeListToUpdate;
    this.data.REPORTER_ID = this._apiService.userId;

    // var assigndata = this.mappingData.filter((ass)=>{
    //   return ass['IS_ACTIVE'] == 1;
    // })
    var assigndata = [];
    for (var i = 0; i < this.mappingData.length; i++) {
      if (this.mappingData[i]["IS_ACTIVE"] == 1) {
        assigndata.push(Number(this.mappingData[i]["USER_ID"]));
      }
    }

    console.log(assigndata, "assigndata");

    var dataaa = {
      TYPE: this.data.TYPE,
      REFERENCE_ID: this.data.ID,
      REPORTER_ID: this.data.REPORTER_ID,
      CLIENT_ID: 1,
      ASSIGNEES: assigndata,
    };

    this._apiService.updateTaskSubtasknew(dataaa).subscribe(
      (successCode) => {
        if (successCode["code"] == "200") {
          this.notificationSer.success("Task Updated Successfully", "");
        } else {
          this.notificationSer.error("Failed to Update Task", "");
        }
      },
      (err) => {
        if (err["ok"] == false) {
          this.notificationSer.error("Server Not Found", "");
        }
      }
    );
  }
}
